import * as Yup from 'yup'

export default Yup.object().shape({
  domain: Yup.string()
})